export const USER_TYPE_REGULAR_USER = 0;
export const USER_TYPE_PERFORMER = 1;

export const USER_DOCUMENT_NONE = 0;
export const USER_DOCUMENT_PENDING = 1;
export const USER_DOCUMENT_APPROVED = 2;
export const USER_DOCUMENT_DECLINED = 3;

export const USER_BACKGROUND_UNCHECKED = 0;
export const USER_BACKGROUND_CHECKED = 1;

export const ONLINE_STATUS = "online";
export const OFFLINE_STATUS = "offline";

export const USER_FIELDS = [
  'category',
  'ethnicity',
  'body_type',
  'education',
  'occupation',
  'drinking',
  'smoking',
  'children',
  'relationship_status',
  'looking_for',
  'seeking',
  'seeking_description',
  'preferred_min_age',
  'preferred_max_age'
];

export default {
  isRegular,
  isPerformer,
  isDocumentNone,
  hasVerifiedCards,
  isDocumentPending,
  isDocumentApproved,
  isDocumentDeclined,
  isPerformerNotApproved,
  isPerformerDocumentApprovedOrPending,
  isPerformerPendingApproval,
  isPerformerRequiredToUploadProfilePicture,
  isEmailVerified,
  isFace2facePackageMissingForPerformer,
  isPerformerUsingDefaultFace2facePackage,
  isUserNeedToUpdateProfile,
  isBackgroundChecked,
  isUserTraveling,
};


function isRegular(user) {
  return user?.user_type === USER_TYPE_REGULAR_USER;
}

function isPerformer(user) {
  return user?.user_type === USER_TYPE_PERFORMER;
}

function hasVerifiedCards(user) {
  return  user?.total_cards ;
}

function isDocumentApproved(user) {
  return user?.is_document_verified === USER_DOCUMENT_APPROVED;
}

function isDocumentNone(user) {
  return user?.is_document_verified === USER_DOCUMENT_NONE;
}

function isDocumentPending(user) {
  return user?.is_document_verified === USER_DOCUMENT_PENDING;
}

function isDocumentDeclined(user) {
  return user?.is_document_verified === USER_DOCUMENT_DECLINED;
}

function isPerformerDocumentApprovedOrPending(user) {
  return (
    user?.user_type === USER_TYPE_PERFORMER &&
    (user?.is_document_verified === USER_DOCUMENT_NONE || user?.is_document_verified === USER_DOCUMENT_DECLINED)
  );
}

function isPerformerNotApproved(user) {
  return (
    user?.user_type === USER_TYPE_PERFORMER &&
    (user?.is_document_verified !== USER_DOCUMENT_APPROVED)
  );
}

function isPerformerPendingApproval(user) {
  return (
    user?.user_type === USER_TYPE_PERFORMER &&
    user?.is_document_verified === USER_DOCUMENT_PENDING
  );
}

function isPerformerRequiredToUploadProfilePicture(user) {
  return (
    user?.user_type === USER_TYPE_PERFORMER && 
    !user?.has_valid_profile_picture
  )
}

function isUserNeedToUpdateProfile(user) {
  if (Object.keys(user).length === 0) {
    return { showAlert: false, message: "" };
  }
  let missingFields = [];
  for (const field of USER_FIELDS) {
    if (user[field] === undefined || !user[field] ) {
      missingFields.push(field);
    }
  }

  let alertMessage = "";
  if (missingFields.length > 0) {
    if (!user.has_valid_profile_picture) {
      alertMessage = `Hey ${user?.username}! Please upload a profile picture and complete all other missing information by clicking 'Update Profile'.`;
    } else {
      alertMessage = `Hey ${user?.username}! Some profile details are missing. Please click 'Update Profile' to complete your profile.`;
    }
    return { showAlert: true, message: alertMessage };
  }

  if (!user.has_valid_profile_picture) {
    alertMessage = `Hey ${user?.username}! Please upload a profile picture by clicking 'Update Profile' to gain full access to the platform.`;
    return { showAlert: true, message: alertMessage };
  }

  return { showAlert: false, message: "" };
}

function isEmailVerified(user) {
  return user.is_email_verified === 1
}

function isFace2facePackageMissingForPerformer(user) {
  return isPerformer(user) && user.has_face2face_package === 0
}

function isPerformerUsingDefaultFace2facePackage(user) {
  return isPerformer(user) && user.has_default_face2face_package === 1
}

function isBackgroundChecked(user) {
  return user.is_background_checked === USER_BACKGROUND_CHECKED
}

function isUserTraveling(user) {
  return user.is_traveling === true || user.is_traveling === 1 || user.is_traveling === "1";
}
